import React, { Component } from "react";

class Giveaway extends Component {
  render() {
    return (
      <div style={{ margin: "2.5rem" }}>
        <meta httpEquiv="content-type" content="text/html; charset=utf-8" />
        <title />
        <meta name="generator" content="LibreOffice 6.4.7.2 (Linux)" />
        <meta name="author" content="Catarina Mendes (EVIO)" />
        <meta name="created" content="2023-09-27T13:41:00" />
        <meta name="changedby" content="Catarina Mendes (EVIO)" />
        <meta name="changed" content="2023-09-27T13:41:00" />
        <meta name="AppVersion" content={16.0} />
        <meta name="DocSecurity" content={4} />
        <meta name="HyperlinksChanged" content="false" />
        <meta name="LinksUpToDate" content="false" />
        <meta name="ScaleCrop" content="false" />
        <meta name="ShareDoc" content="false" />
        <style
          type="text/css"
          dangerouslySetInnerHTML={{
            __html:
              "\n\t\t@page { size: 21.59cm 27.94cm; margin: 2.54cm }\n\t\tp { margin-bottom: 0.25cm; direction: ltr; line-height: 115%; text-align: left; orphans: 2; widows: 2; background: transparent }\n\t\ta:link { color: #0563c1; text-decoration: underline }\n\t",
          }}
        />
        <p
          align="center"
          style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
        >
          <font size={3} style={{ fontSize: "12pt" }}>
            <span lang="pt-PT">
              <b>Regulamento EVIO</b>
            </span>
          </font>
        </p>
        <p
          align="center"
          style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
        >
          <font size={3} style={{ fontSize: "12pt" }}>
            <span lang="pt-PT">
              <b>"Roleta EVIO" - Conferência de Gestão de Frotas</b>
            </span>
          </font>
        </p>
        <p lang="pt-PT" style={{ marginBottom: "0.28cm", lineHeight: "108%" }}>
          <br />
          <br />
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            lineHeight: "108%",
          }}
        >
          <span lang="pt-PT">
            1. Empresa promotora e apresentação da Oferta:
          </span>
        </p>

        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            1.1 A EVIO - ELECTRICAL MOBILITY, S.A., pessoa coletiva nº.
            515681890, com sede em Avenida Dom Afonso Henriques 1825, 4450-017
            Matosinhos, adiante designada simplesmente por “EVIO”, promove a
            Oferta "Roleta EVIO" (doravante referido como "a Oferta") no evento
            Conferência de Gestão de Frotas - Porto e Lisboa.
          </span>
        </p>
        <p lang="pt-PT" style={{ marginBottom: "0.28cm", lineHeight: "108%" }}>
          <br />
          <br />
        </p>
        <p style={{ marginBottom: "0.28cm", lineHeight: "108%" }}>
          <span lang="pt-PT">2. Participação:</span>
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            2.1 A participação na Oferta é gratuita e aberta a todas as pessoas
            maiores de 18 anos, participantes na Conferência de Gestão de Frotas
            - Porto e Lisboa.
          </span>
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            2.2 Cada pessoa só pode participar uma vez na Oferta.
          </span>
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            2.3 O Participante deverá indicar o seu nome completo, email
            profissional, número de telemóvel para contacto e NIF da empresa.
          </span>
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            2.4 As participações que não satisfaçam integralmente as Condições e
            Requisitos estabelecidos neste Regulamento não serão consideradas
            para efeitos da Oferta.
          </span>
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            2.5 A Empresa Promotora reserva-se o direito de, após verificar a
            existência de qualquer violação do presente Regulamento ou qualquer
            indício de participação fraudulenta, desclassificar o Participante
            em causa e excluí-lo da Oferta.
          </span>
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            2.6 A participação na Oferta implica a aceitação integral e sem
            reservas deste regulamento.
          </span>
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            2.7 É proibida a participação na presente Oferta para fins
            contrários à Lei, que suponham um prejuízo para terceiros, ou de
            qualquer forma lesem a sua honra, dignidade, imagem, intimidade,
            crenças religiosas, ideologias ou qualquer outro direito reconhecido
            legalmente.
          </span>
        </p>
        <p lang="pt-PT" style={{ marginBottom: "0.28cm", lineHeight: "108%" }}>
          <br />
          <br />
        </p>
        <p style={{ marginBottom: "0.28cm", lineHeight: "108%" }}>
          <span lang="pt-PT">3. Mecânica da Oferta:</span>
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            3.1 A Oferta será realizada através de uma roleta eletrónica.
          </span>
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">3.2 Os prémios disponíveis são os seguintes:</span>
        </p>
        <ol style={{ marginLeft: "2cm", lineHeight: "108%" }}>
          <p style={{ marginBottom: "0.28cm", lineHeight: "108%", marginLeft: "-1cm"}}>
            <span lang="pt-PT">
              Sorteio individual, um prémio por participante: 
            </span>
          </p>
        
          <ol type="a">
            <li>
              <p style={{ marginBottom: "0.28cm", lineHeight: "108%" }}>
                <span lang="pt-PT">
                  Caneta EVIO 
                </span>
              </p>
            </li>
            <li>
              <p style={{ marginBottom: "0.28cm", lineHeight: "108%" }}>
                <span lang="pt-PT">
                  Caderno EVIO 
                </span>
              </p>
            </li>
            <li>
              <p style={{ marginBottom: "0.28cm", lineHeight: "108%" }}>
                <span lang="pt-PT">
                  PowerBank EVIO 
                </span>
              </p>
            </li>
          </ol>
          <ol type="a">
            <p style={{ marginBottom: "0.28cm", lineHeight: "108%", marginLeft: "-1cm"}}>
              <span lang="pt-PT">
              Sorteio geral, um prémio aleatório por cada vencedor: 
              </span>
            </p>
            <li>
              <p style={{ marginBottom: "0.28cm", lineHeight: "108%" }}>
                <span lang="pt-PT">
                  Trotinete Elétrica
                </span>
              </p>
            </li>
            <li>
              <p style={{ marginBottom: "0.28cm", lineHeight: "108%" }}>
                <span lang="pt-PT">
                  Smartband
                </span>
              </p>
            </li>
            <li>
              <p style={{ marginBottom: "0.28cm", lineHeight: "108%" }}>
                <span lang="pt-PT">
                  Auriculares sem fios
                </span>
              </p>
            </li>
          </ol>
        </ol>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            3.3 Os prémios serão sorteados aleatoriamente entre os participantes
            da Oferta.
          </span>
        </p>
        <p lang="pt-PT" style={{ marginBottom: "0.28cm", lineHeight: "108%" }}>
          <br />
          <br />
        </p>
        <p style={{ marginBottom: "0.28cm", lineHeight: "108%" }}>
          <span lang="pt-PT">4. Realização da Oferta:</span>
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            4.1 A Oferta será realizada no dia 21 de maio e no dia 21 de
            novembro de 2024, no evento Conferência de Gestão de Frotas - Porto
            e Lisboa.
          </span>
        </p>
        <p lang="pt-PT" style={{ marginBottom: "0.28cm", lineHeight: "108%" }}>
          <br />
          <br />
        </p>
        <p style={{ marginBottom: "0.28cm", lineHeight: "108%" }}>
          <span lang="pt-PT">5. Entrega dos Prémios:</span>
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            5.1 Os vencedores que cumpram os critérios de participação, serão
            contactados pela EVIO para a entrega dos respetivos prémios.
          </span>
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            5.2 Os prémios são pessoais e intransmissíveis, não podendo ser
            trocados por dinheiro ou por outros produtos/serviços.
          </span>
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            5.3 A EVIO reserva-se ao direito de substituir os prémios por outros
            de igual ou superior valor, em caso de impossibilidade de entrega
            dos prémios inicialmente anunciados.
          </span>
        </p>
        <p lang="pt-PT" style={{ marginBottom: "0.28cm", lineHeight: "108%" }}>
          <br />
          <br />
        </p>
        <p style={{ marginBottom: "0.28cm", lineHeight: "108%" }}>
          <span lang="pt-PT">6. Proteção de Dados:</span>
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            6.1 Os dados pessoais dos participantes serão recolhidos para
            efeitos de gestão da Oferta e de comunicação da EVIO e não serão
            partilhados com terceiros sem o consentimento prévio dos
            participantes.
          </span>
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            6.2 A entidade responsável pelo tratamento dos dados pessoais é a
            EVIO - ELECTRICAL MOBILITY, S.A.
          </span>
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            6.3 A EVIO designou um encarregado da proteção de dados que poderá
            ser diretamente contactado através de carta enviada para EVIO -
            ELECTRICAL MOBILITY, S.A., Avenida Dom Afonso Henriques 1825,
            4450-017 Matosinhos ou para o endereço evio@go-evio.com.
          </span>
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            6.4 O tratamento de dados para fins de marketing será efetuado de
            acordo com a opção de consentimento manifestada pelo participante. O
            consentimento deve ser prévio, livre, informado, específico e
            inequívoco, manifestado numa declaração escrita, oral ou através da
            validação de uma opção. O participante pode opor-se ao tratamento de
            dados para fins de marketing a qualquer momento e por qualquer meio.
          </span>
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            6.5 Os dados pessoais são conservados por períodos de tempo
            diferentes, consoante a finalidade a que se destinam e tendo em
            conta critérios legais, de necessidade e minimização do tempo de
            conservação.
          </span>
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            6.6 A EVIO pode recorrer a subcontratantes para efeitos do
            tratamento de dados pessoais, nomeadamente para gestão da Oferta,
            seleção do vencedor e entrega do prémio, ficando estas entidades
            obrigadas a desenvolver as medidas técnicas e organizativas
            adequadas à proteção dos dados e assegurar a defesa dos direitos do
            titular. Em determinadas circunstâncias, certos dados pessoais
            poderão ter de ser comunicados a autoridades públicas, como por
            exemplo, a Secretaria Geral do Ministério da Administração Interna,
            autoridade tributária, tribunais e forças de segurança.
          </span>
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            6.7 É garantido ao participante o direito de acesso, retificação,
            oposição, apagamento, limitação e portabilidade dos seus dados
            pessoais. O exercício dos direitos pode ser solicitado mediante
            pedido escrito enviado para EVIO, Avenida Dom Afonso Henriques 1825,
            4450-017 Matosinhos ou para o endereço{" "}
            <a href="mailto:evio@go-evio.com">evio@go-evio.com</a>.
          </span>
        </p>
        <p lang="pt-PT" style={{ marginBottom: "0.28cm", lineHeight: "108%" }}>
          <br />
          <br />
        </p>
        <p style={{ marginBottom: "0.28cm", lineHeight: "108%" }}>
          <span lang="pt-PT">7. Disposições Finais:</span>
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            7.1 A participação na presente Oferta implica a aceitação integral e
            incondicional do presente Regulamento pelos participantes e as
            decisões da Empresa Promotora são consideradas definitivas.{" "}
          </span>
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            7.2 A EVIO reserva-se ao direito de, a qualquer momento, cancelar,
            alterar ou suspender a Oferta, caso ocorram circunstâncias
            imprevistas que o justifiquem.
          </span>
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            7.3 Apenas são admitidas as participações que estejam em
            conformidade com o presente Regulamento. Qualquer participação por
            meio diverso do previsto neste Regulamento não será considerada.
          </span>
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            7.4 O presente regulamento poderá ser alterado pela EVIO, sendo que
            as alterações serão devidamente comunicadas aos participantes.
          </span>
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            7.5 Para qualquer questão relacionada com a Oferta, os participantes
            podem entrar em contacto com a EVIO através dos canais de
            comunicação disponibilizados pela empresa.
          </span>
        </p>
        <p lang="pt-PT" style={{ marginBottom: "0.28cm", lineHeight: "108%" }}>
          <br />
          <br />
        </p>
        <p style={{ marginBottom: "0.28cm", lineHeight: "108%" }}>
          <span lang="pt-PT">8. Responsabilidade:</span>
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            8.1. A Empresa Promotora SA não é responsável por participações
            perdidas, atrasadas, incompletas, inválidas, extraviadas ou
            corrompidas, as quais não serão consideradas para efeitos de
            participação na Oferta.
          </span>
        </p>
        <p
          style={{
            marginBottom: "0.28cm",
            marginLeft: "1cm",
            lineHeight: "108%",
          }}
        >
          {" "}
          <span lang="pt-PT">
            8.2. A Empresa Promotora não é responsável por transmissões
            eletrónicas incompletas ou tenham sofrido falhas, bem como por
            falhas técnicas de qualquer tipo, incluindo, mas não limitadas ao
            mau funcionamento de qualquer rede, “hardware” ou “software”.
          </span>
        </p>
      </div>
    );
  }
}

export default Giveaway;
